import * as React from "react"
import "../../styles/styles.sass"
import SidebarNavigation from "../../components/sidebarNavigation"
import TitleBar from "../../components/titleBar"
import FormInput from "../../components/form"
import PopUpButton from "../../components/popUpButton"

// Markup
const FormPage = () => {
  return (
    <main className="lighthouseView componentDetails formView">
      <title>Form</title>
      <SidebarNavigation selectTab1="true"/>

      <div className="viewWindow">
        <TitleBar title="Form" actions="" type="detail" backLink="/" backTitle="Components"/>

        <div className="viewContent">
          <FormInput type="text" size="medium" hierarchy="primary" content="titledInput" state="" title="Full Name" name="full-name" placeholder="Jonny Appleseed" />
          <FormInput type="text" size="medium" hierarchy="primary" content="titledInput" state="" title="Street" name="street" placeholder="1 Apple Drive" />
          
          <div className="spacer"/>

          <FormInput type="text" size="medium" hierarchy="primary" content="inputOnly" state="" title="Full Name" name="full-name" placeholder="Jonny Appleseed" />
          <FormInput type="text" size="medium" hierarchy="primary" content="inputOnly" state="" title="Street" name="street" placeholder="1 Apple Drive" />

          <div className="spacer"/>

          <FormInput type="text" size="large" hierarchy="primary" content="titledInput" state="" title="Full Name" name="full-name" placeholder="Jonny Appleseed" />
          <FormInput type="text" size="large" hierarchy="primary" content="titledInput" state="" title="Street" name="street" placeholder="1 Apple Drive" />

          <div className="spacer"/>

          <FormInput type="text" size="large" hierarchy="primary" content="inputOnly" state="" title="Full Name" name="full-name" placeholder="Jonny Appleseed" />
          <FormInput type="text" size="large" hierarchy="primary" content="inputOnly" state="" title="Street" name="street" placeholder="1 Apple Drive" />

          <div className="spacer"/>

          <FormInput
            size="medium" hierarchy="primary" content="selection" state=""
            title="Title"
            name="type[]"
            options={<>
              <option value="option1">Option 1</option>
              <option value="option2">Option 2</option>
              <option value="option3">Option 3</option>
            </>}
          />
        </div>
      </div>
    </main>
  )
}

export default FormPage
